import React from 'react';
import { Loader2, Lock } from 'lucide-react';
import type { CheckoutState } from '../../../hooks/useReportUnlock';
interface UnlockButtonProps {
  label: string;
  state: CheckoutState;
  onClick: () => void;
  variant?: 'primary' | 'outline';
  fullWidth?: boolean;
}

/** The single $2.99 unlock control, reused by every locked surface. */
export function UnlockButton({
  label,
  state,
  onClick,
  variant = 'primary',
  fullWidth = false
}: UnlockButtonProps) {
  const busy = state === 'starting' || state === 'redirecting' || state === 'confirming';
  const busyLabel = state === 'starting' ? 'Opening secure checkout…' : state === 'redirecting' ? 'Redirecting to checkout…' : 'Confirming payment…';
  const base = 'inline-flex min-h-[52px] items-center justify-center gap-2 rounded-xl px-4 text-[13px] font-semibold min-[400px]:text-sm transition-[background-color,border-color,color,transform] duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-forensic-crimson-soft focus-visible:ring-offset-2 focus-visible:ring-offset-forensic-bg active:scale-[0.98] disabled:cursor-wait disabled:opacity-80 sm:px-6';
  const styles = variant === 'primary' ? 'bg-forensic-crimson text-white hover:bg-forensic-crimson-hover' : 'border border-forensic-line-strong text-white hover:border-white/30 hover:bg-white/[0.03]';
  return <button type="button" onClick={onClick} disabled={busy} aria-busy={busy} className={`${base} ${styles} ${fullWidth ? 'w-full' : ''}`} data-id="element-433" data-mp="rzzid0lvx2lr">
      {busy ? <Loader2 size={16} className="shrink-0 animate-spin" aria-hidden="true" data-id="element-434" data-mp="11wuh9km2l50k" /> : <Lock size={16} className={`shrink-0 ${variant === 'outline' ? 'text-forensic-crimson-soft' : ''}`} aria-hidden="true" data-id="element-435" data-mp="16om7fu1bd8q6" />}
      <span className="whitespace-nowrap" data-id="element-436" data-mp="96vtdsjm3dxh">{busy ? busyLabel : label}</span>
    </button>;
}